import Vue from 'vue'
import Vuex from 'vuex'


Vue.use(Vuex)


export default new Vuex.Store({
    state: {
        navCurrentIndex: 0,
        i18n: true,
        vals: 0,
    },
    mutations: {
        setNavCurrentIndex(state, navCurrentIndex) {
            state.navCurrentIndex = navCurrentIndex
        },
        setI18n(state) {
            state.i18n = !state.i18n;
        },
        getVal(state) {
            state.vals = state.vals + 1
        },
    },
    actions: {

    }
});


// WEBPACK FOOTER //
// ./src/store/index.js